import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll the window back to the top whenever the pathname changes.
 * React Router doesn't handle scroll restoration by default, so every
 * navigation would otherwise inherit the previous page's scroll position —
 * e.g. clicking "See plans" halfway down /dashboard would land on /pricing
 * scrolled to the middle of the page.
 *
 * Renders nothing — mounts once inside the router.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use `auto` so it doesn't animate — feels snappier and matches the
    // browser's own back/forward behavior.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
